// Contact placeholders - edit here to update across the site
export const CONTACT = {
    phone: "+52 56 4881 7424",
    whatsappNumber: "525648817424", // without + or spaces
    email: "contacto@terah.mx",
    address: "Plutarco Elías Calles 2513",
    city: "CDMX / México",
    instagram: "https://instagram.com/terah",
    linkedin: "https://linkedin.com/company/terah",
    hours: "L–V · 08:00 — 18:00",
};

export const WHATSAPP_URL = `https://wa.me/${CONTACT.whatsappNumber}?text=${encodeURIComponent(
    "Hola Terah, quisiera una cotización para servicios de TI."
)}`;

export const MAILTO_URL = `mailto:${CONTACT.email}?subject=${encodeURIComponent(
    "Solicitud de cotización - Terah"
)}&body=${encodeURIComponent(
    "Hola, me gustaría más información sobre sus servicios."
)}`;
